<h1>Site em construção</h1>

<app-heroes></app-heroes>

<footer>
  &copy; 2020 by Pedro Guilherme Siqueira Moreira
</footer>
